/**
 * filename：en.js
 */
export const h = {
  // 通用文本
  home: 'Home',
  login: 'Login',
  register: 'Register',
  logout: 'Logout',
  logoutConfirmMsg: 'Are you sure you want to logout?',
  confirm: 'Confirm',
  cancel: 'Cancel',
  submit: 'Submit',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  search: 'Search',
  reset: 'Reset',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  index: 'No.',
  close: 'Close',
  open: 'Open',
  loading: 'Loading',
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  action: 'Action',
  viewDetail: 'View Details',
  language: 'Language',
  chinese: 'Chinese',
  english: 'English',

  // 登录注册相关
  loginTitle: 'Login',
  emailLogin: 'Email Login',
  phoneLogin: 'Phone Login',
  passwordLogin: 'Password Login',
  codeLogin: 'Code Login',
  registerTitle: 'Register',
  phoneNumber: 'Phone Number',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  verificationCode: 'Verification Code',
  sendCode: 'Send Code',
  resendCode: 'Resend Code',
  loginButton: 'Login',
  registerButton: 'Register',
  forgotPassword: 'Forgot Password',
  rememberPassword: 'Remember Password',
  loginSuccess: 'Login Successful!',
  registerSuccess: 'Registration Successful!',
  loginFailed: 'Login Failed',
  registerFailed: 'Registration Failed',
  pleaseEnterPhone: 'Please enter phone number',
  mainlandPlayerNotice: 'Mainland players please use the "Chinese-English Pinyin" mini-program for registration and login.',
  pleaseEnterPassword: 'Please enter password',
  pleaseEnterCode: 'Please enter verification code',
  pleaseEnterCorrectPhone: 'Please enter correct phone number',
  pleaseEnterCorrectEmail: 'Please enter correct email',
  codeSentSuccess: 'Verification code sent successfully, please check',
  codeSentFailed: 'Failed to send verification code',
  passwordNotMatch: 'Passwords do not match',
  phoneRequired: 'Please enter phone number',
  emailRequired: 'Please enter email',
  passwordRequired: 'Please enter password',
  codeRequired: 'Please enter verification code',
  passwordLength: 'Password must be at least 6 characters',
  seconds: ' seconds later ',
  partnerLoginDesc: 'Organizer Login',
  studentLoginDesc: 'Student Login',
  teacherLoginDesc: 'Teacher Login',
  pleaseChooseLoginType: 'Please Choose Login Type',
  // Compatibility for legacy Chinese keys used directly in $t()
  // 导航菜单
  aboutCebsb: 'About CEBSB',
  competitions: 'About Competition',
  forSpellers: 'For Spellers',
  forSchools: 'For Schools',
  globalPartnership: 'Global Partnership',
  joinUs: 'Join Us',
  certificateVerification: 'Certificate Inquiry',
  eLearn: 'E-Learn',
  globalFinals: 'Global Finals',
  FAQ: 'FAQ',

  // 关于CEBSB
  background: 'Background',
  vision: 'Vision',
  committee: 'Committee',
  honour: 'Honor',
  history: 'History',

  // 子菜单标题
  backgroundTitle: '·Background',
  visionTitle: '·Vision',
  committeeTitle: '·Committee',
  honourTitle: '·Honor',
  individualCompetitionsTitle: '·Individual Competitions',
  teamCompetitionsTitle: '·Team Competitions',
  registerForCompetitionTitle: '·Register for Competition',
  onlineLearningResourceTitle: '·Online Learning Resource',
  characterBankTitle: '·CEBSB-Chinese Character Bank',
  certificateVerificationTitle: '·Certificate Inquiry',
  beeFunCarnivalTitle: '·Bee Fun Carnival-Future Champion Camp',
  teamCompetitionTrainingTitle: '·Team Competitions Training',
  sisterSchoolEstablishmentTitle: '·Sister School Establishment',
  membershipEnrollmentTitle: '·Membership Enrollment',
  beeFunActivityTitle: '·Bee Fun Activity',
  schoolFaqsTitle: '·FAQs',
  partnerTitle: '·Partner',
  judgesAndCoachesTitle: '·Judges and Coaches',
  volunteersTitle: '·Volunteers',

  // 菜单描述文字
  aboutCebsbDesc: 'CEBSB is the first Chinese-English bilingual communication activity based on Spelling Bee and integrating Chinese cultural elements. CEBSB helps K-12 learners at home and abroad to strengthen their core language literacy, while deepening their comprehension of global expression of Chinese culture and Chinese understanding of the diverse cultures around the world.',
  competitionsDesc: 'Competitions include individual competitions and team competitions. The game-based competitive activities link Chinese and English, combine learning with application, and effectively promote the Chinese-English bilingual acquisition of the spellers, strengthen their learning initiative and enhance their multicultural perspectives.',
  forSpellersDesc: 'This exclusive platform is well prepared for spellers to improve their language literacy. Provided with online learning resources, a large character bank and colorful Inquiry Camp activities, spellers can easily find their way to this fascinating Chinese-English bilingual spelling event at multiple levels and dimensions.',
  forSchoolsDesc: 'We are willing to cooperate closely with schools to carry out team competition training, promote the establishment of sister schools, organize Bee Fun activities, and jointly cultivate future talents with cross-cultural thinking and global understanding.',
  joinUsDesc: 'We have a grand dream to connect the world with diverse language and culture, and we are committed to creating a platform for young people all over the world to learn Chinese and English and exchange ideas. If you have a strong interest in cooperation, we will provide you with the broadest stage. Welcome to join us!',

  // 重置密码相关
  resetPassword: 'Reset Password',
  backToLogin: 'Back to Login',
  inputEmail: 'Enter Email',
  verify: 'Verify',
  setNewPassword: 'Set New Password',
  complete: 'Complete',
  verifyRegistrationEmail: 'Verify Registration Email',
  nextStep: 'Next Step',
  verificationCodeSent: 'Verification code has been sent to email',
  pleaseCheckEmail: 'Please check your email',
  setNewPasswordTitle: 'Set New Password',
  newPassword: 'New Password',
  confirmModify: 'Confirm Modify',
  passwordSetComplete: 'Password Set Complete',
  redirectInSeconds: 's redirect to login page',
  redirectNow: 'Redirect Now',
  pleaseEnterPasswordAgain: 'Please enter password again',
  passwordsDoNotMatch: 'Passwords do not match!',
  emailCannotBeEmpty: 'Email cannot be empty',
  pleaseEnterCorrectEmailFormat: 'Please enter correct email format',
  pleaseEnterVerificationCode: 'Please enter verification code',

  // 练习相关
  funLearning: 'Fun Learning',
  practiceExperience: 'Practice Experience',
  challengePractice: 'Challenge Practice',
  limitedTimeFree: 'Example Questions',
  questionPaper: 'Question Paper',
  unlockQuestionPapers: 'Unlock Question Papers 1-4',
  pleaseUnlockFirst: 'Please unlock question papers first',

  // 答题相关
  exit: 'Exit',
  skip: 'Skip',
  nextQuestion: 'Next Question',
  confirmSkip: 'Skip this question? Confirming skip will end the experience',
  confirmSkipButton: 'Confirm Skip',
  continueAnswer: 'Continue Answer',
  pleaseSelectAnswer: 'Please select an answer',
  congratulations: 'Congratulations!',
  keepTrying: 'Sorry, keep trying!',
  goToAnswer: 'Go to Answer',
  errorMinus20s: 'Error -20s',
  definition: 'Definition',
  sentenceStr: 'Sentence',
  pinyin: 'Pinyin',
  tip: 'Tip',

  // 字库相关
  lexiconDirectory: 'Lexicon Directory',
  chineseEnglishSpellingBee: 'Chinese-English Spelling Bee',
  lexicon: 'Lexicon',
  warmReminder: 'Warm Reminder',
  lexiconUnlockNotice: 'Users in Mainland China can use the "汉英双拼" WeChat Mini Program to unlock word banks individually or receive the corresponding group word bank as a gift when registering for Chinese-English competitions. For users from Hong Kong, Macao, Taiwan (China) and overseas who have difficulty using WeChat, please click the bottom right corner to register for the competition. The organizing committee will collect your information and process the word bank unlock within 1-7 working days.',
  goToRegister: 'Register',
  // 字库目录相关
  pleaseEnterContent: 'Please Enter Content',
  noData: 'No Data Available',
  personalInfo: 'Personal Information',
  orderPayment: 'Order Payment',
  chineseEnglishDictionary: 'Chinese-English Dictionary',
  studentHomepage: 'User Homepage',
  funLearningResult: 'Fun Learning',
  individualCompetitionCityPreliminary: 'City Preliminary of Individual Competition',
  elementaryGroup: 'Elementary Group',

  // 赛事相关
  individualCompetition: 'Individual Competition',
  teamCompetition: 'Team Competition',
  cityPreliminary: 'Preliminary Competition',
  cityReplay: 'City Replay',
  regionalFinal: 'Division Finals',
  nationalFinal: 'Global Finals',
  nationalFinals: 'Global Finals',
  preliminaryCompetition: 'Preliminary Competition',
  divisionFinals: 'Division Finals',

  // 选手专区
  registerForCompetition: `Register for
  Competition`,
  onlineLearningResource: 'Online Learning Resources',
  beeFunCarnival: 'Bee Fun Carnival',
  characterBank: 'Character Bank',
  characterBankSubtitle: 'View and manage Chinese character bank resources',
  practiceQuestions: 'Practice Questions',
  practiceQuestionsSubtitle: 'View and manage practice question resources',
  featureComingSoon: 'This feature is under development. Please stay tuned.',
  resourceTools: 'Character Bank Study',
  competitionPreparation: 'Competition Preparation',
  faqs: 'Frequently Asked Questions (FAQs)',

  // 学校专区
  teamCompetitionTraining: 'Team Competition Training',
  sisterSchoolEstablishment: 'Sister School Establishment',
  membershipEnrollment: 'Membership Enrollment',
  beeFunActivity: 'Bee Fun Activities',
  schoolFaqs: 'School FAQs',

  // 加入我们
  partner: 'Cooperation Partners',
  judgesAndCoaches: 'Judges and Coaches',
  volunteers: 'Volunteers',

  // 用户中心
  userCenter: 'User Center',
  studentHome: 'User Homepage',
  orderList: 'Order List',

  // 登录相关
  studentLogin: 'Student Login',
  partnerLogin: 'Organizer Login',
  teacherLogin: 'Teacher Login',
  welcomeBack: 'Welcome back, please login to your account',
  applyForRegistration: 'Apply for Registration',
  applyForCommittee: 'Apply to Become Committee',
  applicantName: 'Applicant Name',
  applicantPosition: 'Position',
  registerEmail: 'Registration Email',
  contactPhone: 'Contact Phone',
  country: 'Country',
  pleaseSelectCountry: 'Please select country',
  pleaseEnterCountry: 'Please enter your country',
  applyReason: 'Application Reason',
  pleaseEnterApplyReason: 'Please enter application reason',
  applySuccess: 'Application submitted successfully',
  applyFailed: 'Application submission failed',
  other: 'Other',
  progressQuery: 'Progress Query',
  queryCode: 'Query Code',
  pleaseEnterQueryCode: 'Please enter query code',
  copy: 'Copy',
  copySuccess: 'Copy successful',
  copyFailed: 'Copy failed',
  queryProgress: 'Query Progress',
  queryFailed: 'Query failed',
  applicationStatus: 'Application Status',
  applicationTime: 'Application Time',
  reviewTime: 'Review Time',
  reviewResult: 'Review Result',
  reviewRemark: 'Review Remark',
  rejectionReason: 'Rejection Reason',
  reapply: 'Reapply',
  loginNow: 'Login Now',
  approvalCongratulations: 'Congratulations! Your application has been approved. You are now an official committee member. We look forward to working with you!',
  pendingNotice: 'Your submission is under review. The review period is 1-5 business days. Please pay attention to your email for updates. Thank you for your understanding!',

  // 管理后台
  partnerDashboard: 'Institution Management Backend',
  schoolManage: 'School Management',
  schoolManageSubtitle: 'Manage partner school information and related data',
  schoolManageComingSoon: 'School management features are under development. Please stay tuned.',
  schoolList: 'School List',
  addSchool: 'Add School',
  schoolAddress: 'School Address',
  teacherName: 'Teacher Name',
  teacherEmail: 'Teacher Email',
  pleaseEnterSchoolName: 'Please enter school name',
  pleaseEnterSchoolAddress: 'Please enter school address',
  pleaseEnterTeacherName: 'Please enter teacher name',
  pleaseEnterTeacherEmail: 'Please enter teacher email',
  pleaseEnterValidEmail: 'Please enter a valid email address',
  organizationInfo: 'Institution Information',
  managerInfo: 'Person-in-Charge Information',
  examSystem: 'Competition Management',
  examManagement: 'Competition System',
  examTimeManagement: 'Time Management',
  examTimeList: 'Time Schedule List',
  addExamTime: 'Add Time Schedule',
  editExamTime: 'Edit Time Schedule',
  examStartTime: 'Competition Start Time',
  examEndTime: 'Competition End Time',
  releaseTime: 'Time for score release',
  pleaseSelectStartTime: 'Please select start time',
  pleaseSelectEndTime: 'Please select end time',
  publishSelectTime: 'Please select the score release time',
  publishTimeMustAfterEndTime: 'publish time must be after end time',
  endTimeMustAfterStartTime: 'End time must be after start time',
  publishTimeMustAfterStartTime: 'Publish time must be after start time',
  confirmDeleteExamTime: 'Are you sure you want to delete this time schedule?',
  individualScoreQuery: 'Individual Competition Score Inquiry',
  judgeSystem: 'Referee System',
  playerInfo: 'Contestant Information',
  organizationName: 'Institution Name',
  organizationCode: 'Organization Code',
  contactPerson: 'Contact Person',
  contactEmail: 'Contact Email',
  contactInfo: 'Contact Information',
  organizationEmail: 'Organization Email',
  organizationPhone: 'Organization Phone',
  address: 'Address',
  managerName: 'Manager Name',
  managerPhone: 'Manager Phone',
  managerEmail: 'Manager Email',
  content: 'Content',
  title: 'Title',

  // 表单相关
  pleaseSelect: 'Please select',
  pleaseInput: 'Please input ',
  required: 'Required',
  optional: 'Optional',
  name: 'Name',
  gender: 'Gender',
  age: 'Age',
  grade: 'Grade',
  class: 'Class',
  school: 'School',
  phone: 'Phone',
  wechat: 'WeChat',
  qq: 'QQ',
  remark: 'Remark',
  // 比赛相关
  competition: 'Competition',
  exam: 'Exam',
  score: 'Score',
  ranking: 'Ranking',
  certificate: 'Certificate',
  award: 'Award',
  prize: 'Prize',

  // 学习相关
  study: 'Study',
  practice: 'Practice',
  test: 'Test',
  homework: 'Homework',
  course: 'Course',
  lesson: 'Lesson',
  chapter: 'Chapter',
  word: 'Word',
  sentence: 'Sentence',
  grammar: 'Grammar',
  vocabulary: 'Vocabulary',
  pronunciation: 'Pronunciation',
  listening: 'Listening',
  speaking: 'Speaking',
  reading: 'Reading',
  writing: 'Writing',

  // 时间相关
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  thisWeek: 'This Week',
  lastWeek: 'Last Week',
  nextWeek: 'Next Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  nextMonth: 'Next Month',
  thisYear: 'This Year',
  lastYear: 'Last Year',
  nextYear: 'Next Year',

  // 状态相关
  pending: 'Pending',
  processing: 'Processing',
  completed: 'Completed',
  cancelled: 'Cancelled',
  approved: 'Approved',
  rejected: 'Rejected',
  active: 'Active',
  inactive: 'Inactive',
  online: 'Online',
  offline: 'Offline',
  checkRegistrationFailed: 'You haven‘t completed the information yet. Please fill it in first!',
  incompleteInfoTitle: 'Notice',
  incompleteInfoMessage: 'You have not completed your personal information yet. Please complete your information before registering for the competition.',
  goToCompleteInfo: 'Complete Info',
  // 首页相关
  wordEnlightens: 'Word Enlightens',
  world: 'World',
  homeDescription: 'Let your true potential shine with Chinese-English Bilingual Spelling Bee!',

  // 原有内容
  title1: 'List of individual consideration applications',
  back1: 'Return to Home Page',
  contentStr1: 'Apply For Participant Information',
  contentStr2: 'Individual Competition Participant Information',
  contentStr3: ' (Note: As it involves the application for the number of test papers, please fill in the application information carefully. Thank you!)',
  contentStr4: 'Expected exam time',
  contentStr411: 'Season',
  contentStr5: 'Estimated Exam Time',
  contentStr6: 'The school‘s province, city, and district',
  contentStr7: 'School Name',
  contentStr8: 'Participating Grades',
  contentStr9: 'Number of Classes Per Grade',
  contentStr10: 'Estimated Number of Participants',
  contentStr11: 'Remarks (Optional)',
  contentStr12: 'Please Fill in Postscript',
  contentStr13: 'Information for Mailing Address',
  contentStr14: 'Note: As it involves the mailing of competition materials, please fill in the mailing information carefully. Thank you!',
  contentStr15: 'Recipient Name',
  contentStr16: 'Recipient Contact Information',
  contentStr17: 'Email',
  contentStr18: 'Shipping Address',
  contentStr19: 'Detailed Address',
  contentStr20: 'Note: As it involves material preparation, please fill in carefully. Once submitted, this application cannot be amended. If modification is needed, please contact the city committee teacher!',
  contentStr21: 'city committee teacher!',
  contentStr22: 'Submit Information',
  contentStr23: 'Application Successful. Please wait for the committee to contact you.',
  contentStr24: 'Submitted successfully. Please wait patiently while the committee reviews your application.',
  contentStr25: 'ITSOx Team Competition Application',
  contentStr26: 'Submit Information',
  contentStr27: 'Qualification Check',
  contentStr28: 'Make a Payment',
  contentStr29: 'Club Group',
  contentStr30: 'Teacher Name',
  contentStr31: 'Teacher Contact Information',
  contentStr32: 'Proposed Number of Teams',
  contentStr33: 'Club Name',
  contentStr34: '1. ITSO x Team Competition Annual Registration Fee: 480 RMB/team/season;',
  contentStr35: '2. Each school can register up to 2 teams in the same group;',
  contentStr36: '3. Registration is completed only after the committee reviews and confirms the submitted registration information;',
  contentStr37: '4. The registration fee includes: qualification for the 2024-25 ITSOx Team Competition National Finals, participation code certificate, official unified training, 2 official word list manuals for the 2024-25 season, and 1 online word list package;',
  contentStr38: '5. If the registered team pays the annual registration fee but cannot participate in the subsequent competitions of this year due to school or personal reasons, the annual registration fee is non-refundable, but the team still enjoys the above rights;',
  contentStr39: '6. Upon successful registration, the team will receive a certificate with a unique identification code from the committee, which is valid for this year and can be verified on the SPBCN official website;',
  contentStr40: 'Information Review ',
  contentStr41: 'Payment Status',
  contentStr42: 'Unpaid',
  contentStr43: 'Participation Certificate Generated, Click to View',
  contentStr44: 'Review Failed.',
  contentStr45: 'index',
  contentStr46: 'No Estimated Number information available',
  contentStr47: 'Estimated Number',
  contentStr48: 'Estimated Exam Time',
  contentStr49: 'View Details',
  contentStr50: 'Operation',
  contentStr51: 'place select',
  contentStr52: 'place input',
  contentStr53: '(sending the audio used in the exam)',
  contentStr54: 'Example: House number of Unit x, Building x, xx Community, town (street)',
  contentStr55: 'Waiting for Committee to Mail Test Papers',
  contentStr56: 'Waiting to Receive Test Papers',
  contentStr57: 'Go Back',
  contentStr58: 'Review Approved',
  contentStr59: 'Refunded',
  contentStr60: 'Resubmit Registration Information',
  contentStr61: 'Paid',
  contentStr62: 'Participation Certificate',
  contentStr63: 'downLoad',
  contentStr64: 'close',
  contentStr65: 'Reason:',
  contentStr66: ' class ',
  contentStr67: 'school login',
  contentStr68: 'phone number',
  contentStr69: 'Return to Home Page',
  contentStr70: 'phone number',
  contentStr71: 'Please enter phone number',
  contentStr72: 'Verification code',
  contentStr73: 'Enter code',
  contentStr74: 'Login',
  contentStr75: 'Please enter the correct mobile phone number',
  contentStr76: 'SMS sent successfully, please check',
  contentStr77: 'Login success',
  contentStr78: 'Send code',
  contentStr79: 'Teacher in charge',
  contentStr80: 'Regist',
  contentStr81: 'Not yet open, stay tuned!',
  contentStr82: 'Congratulations, successfully registered!',
  contentStr83: 'Tips',
  contentStr84: 'confirm',
  contentStr85: 'Cancel',
  studyPlan1: 'Study Plan',
  studyPlanNoData: 'No study plan has been created yet.',
  studyPlanCreate: 'Create',
  studyPlanCancel: 'Cancel ',
  studyPlanSubmit: 'Submit',
  formItem1: 'Plan Name',
  formItem2: 'Plan Type',
  formItem3: 'First Level Attribute',
  formItem4: 'Second Level Attribute',
  formItem5: 'Start and End Time',
  formTypeWeek: 'Weekly Plan',
  formTypeMonth: 'Monthly Plan',
  formTypeSemester: 'Semester Plan',
  formTypeYear: 'Academic Year Plan',
  rsp: 'to',
  sp: 'Start Date',
  ep: 'End Date',
  np: 'Please enter plan name.',
  tp: 'Please select plan type.',
  rtp: 'Please select start and end time.',
  oneLevelAP: 'Example: Grade',
  oneLevelBP: 'Example: Grade One',
  twoLevelAP: 'Example: Class',
  twoLevelBP: 'Example: 1',
  createTime: 'Creation Time',
  creator: 'Creator',
  state: 'State',
  toWord: 'View Word List',
  studyPlan2: 'Study Plan Word List',
  wordListNoData: 'No Word List Data',
  importWords: 'Import Words in Batches',
  importWordsWithScan: 'Import Words with Scanning pen',
  downLoadTemplate: 'Download Template',
  uploadExcel: 'Confirm Upload',
  chooseExcel: 'Select File',
  wordListTip1: '1、Download Excel Template',
  wordListTip2: '2、Modify Files According to Template Requirements',
  wordListTip3: '3、Click the Button Below to Select a File',
  wordListTip4: '4、Click Confirm to Upload',
  spell: 'Word',
  taskType: 'Teaching Task',
  source: 'Source',
  difficulty: 'Difficulty',
  del: 'Delete',
  delAsk: 'Confirm to delete this word?',
  spellP: 'Please enter the word.',
  hadDel: 'Deleted',
  stuP: 'Please enter your name.',
  phoneP: 'Please enter your phone number.',
  importStudent: 'Import Student Name Lists in Batches',
  import: 'Import in Batches',
  studentNoData: 'No Student Data',
  addbtn: 'Add Student',
  stuName: 'Student Name',
  chooseFileFirst: 'Please select the file to upload.',
  uploadSucc: 'Upload Successfully',
  failReason: 'Please modify and upload again. Reason for failure:',
  failUpload: 'Upload Failed',
  addSucc: 'Added Successfully',
  comfirmToAdd: 'Comfirm to Add',
  state1: 'Normal',
  state2: 'Forbidden',
  delAsk2: 'Confirm to delete this student?',
  base: 'Qualified',
  increase: 'Improve',
  extra: 'Think about it',
  planManagement: 'Plan Management',
  studentManagement: 'Student Management',
  scanNotes1: '1. You need to use WeChat associated with the same phone number to authorize and log in for scanning the pen tool.\\n2. On the website Check the selection box on the left side of the plan list that requires word upload, and click the \'Start Upload\' button at the bottom.\\n3. By clicking on the scanned word result from the pen, you can upload that word to the plan.\\n4. After the upload is completed, click the \'End Upload\' button to finish the current upload session.',
  moreOperation: 'More',
  beginUpLoad: 'Begin upLoad',
  endUpLoad: 'End upload',
  upLoadEndTips: 'Are you sure you want to end the current upload task?',
  upLoadEndTips2: '*Please scan using the scanning pen and select the word upload operation. After the upload is complete, please click the \'End Upload\' button and do not refresh the interface.',
  reloading: 'Loading',
  clickedReloading: 'click refresh',
  competitionPlan: 'Competition plan',
  // Student Dashboard Related
  studentDashboard: 'Student Center',
  account: 'Account',
  lexiconStudy: `Lexicon
  Study`,
  exerciseTraining: `Exercise
  Training`,
  myhomework: `My
  Homework`,
  enterUnlockCode: 'Please Enter Unlock Code',
  unlockCode: 'Unlock Code',
  unlockNow: 'Unlock Now',
  unlockSuccess: 'Unlock successful',
  unlockFailed: 'Unlock failed',
  registrationSuccessMessage: 'Registered successfully! Please proceed to prepare for the competition. Wish you good results!',
  welcomeToStudentCenter: 'Welcome to Student Center',
  userInformation: 'User Information',
  competitionRegistration: 'Register Competition',
  registrationCompleted: 'Registration Completed',
  learningFunctions: 'Learning Functions',
  lexiconStudyDesc: 'Rich lexicon resources to help you expand your vocabulary',
  exerciseTrainingDesc: 'Diverse exercise training to improve your answering skills',
  selectUnlockMethod: 'Select Unlock Method',
  paymentUnlock: 'Payment Unlock',
  paymentUnlockDesc: 'Unlock Registration via Payment',
  codeUnlock: 'Redemption Code Unlock',
  codeUnlockDesc: 'Unlock Registration with Redemption Code',
  unlockCodeTip: 'Please enter your redemption code to complete registration',
  noUnlockCode: 'No redemption code?',
  clickToApply: 'Click to Apply',
  applyUnlockCode: 'Apply for Redemption Code',
  applyUnlockCodeRemark: 'Apply for Remarks',
  pleaseEnterApplyRemark: 'Please enter application remarks',
  applyUnlockCodeNotice: 'After submission, the organizing committee will review and send the redemption code to your email within 1-7 working days. Please remember to check your email!',
  confirmApply: 'Confirm Application',
  registrationSuccess: 'Registration Successful',
  applySuccessTip: 'Your application has been submitted. Please wait patiently. The organizing committee will review and send the redemption code to your email within 1-7 working days. Please remember to check your email!',
  codeManagement: 'Redemption Code Management',
  codeManagementDesc: 'Redemption Code Issuance and Export Function',
  userSignUpList: 'User Sign Up List',
  userSignUpInfo: 'User Sign Up Information',
  promotion: 'Promotion',
  promoted: 'Promoted',
  notPromoted: 'Not Promoted',
  notSet: 'Not Set',
  enrollmentTime: 'Enrollment Time',
  pleaseSelectCommittee: 'Please select committee',
  toolManagement: 'Tool Management',
  // Code Management Related
  infoFilter: 'Information Filter',
  season: 'Season',
  pleaseSelectSeason: 'Please select season',
  unlockRaceSchedule: 'Schedule',
  isUsed: 'Is Used',
  codeInfo: 'Code Information',
  batchExport: 'Batch Export',
  serialNumber: 'NO.',
  raceSchedule: 'Schedule',
  assignedDistrict: 'Assigned District',
  validDays: 'Valid Days',
  used: 'Used',
  unused: 'Unused',
  userName: 'User Name',
  useTime: 'Use Time',
  description: 'Description',
  operation: 'Operation',
  confirmDelete: 'Are you sure to delete this code?',
  deleteSuccess: 'Delete successful',
  exportSuccess: 'Export successful',
  exportFailed: 'Export failed',
  selectRaceSchedule: 'Select Schedule',
  pleaseSelectRaceSchedule: 'Please select Schedule',
  selectRaceScheduleTip: 'Please select the competition stage you want to register for. The system will automatically verify your eligibility.',
  noQualification: 'You are not eligible for this competition stage.',
  checkQualificationFailed: 'Eligibility Inquiry Failed',
  registrationSuccessNotice: 'Registered successfully! Please follow messages from the organizing committee to avoid missing the answer submission deadline.',
  // User Info Edit Related
  editUserInfo: 'Edit User Information',
  avatar: 'Avatar',
  uploadAvatar: 'Upload Avatar',
  cardType: 'ID Type',
  idCard: 'ID Number',
  level: 'Group',
  nationality: 'Nationality',
  nationalityCode: 'Nationality Code',
  sex: 'Gender',
  pleaseEnterName: 'Please enter name',
  pleaseSelectCardType: 'Please select ID type',
  pleaseEnterIdCard: 'Please enter ID number',
  pleaseSelectLevel: 'Please select group',
  pleaseSelectNationality: 'Please select committee',
  pleaseEnterNationalityCode: 'Please enter nationality code',
  pleaseSelectSex: 'Please select gender',
  photoPreview: 'Photo Preview',
  settings: 'Settings',
  saveSuccess: 'Save successful',
  saveFailed: 'Save failed',
  uploadSuccess: 'Upload successful',
  uploadFailed: 'Upload failed',
  // Groups
  groupPrimary: 'Primary Group (Grades 1-2)',
  groupMiddle: 'Middle Group (Grades 3-4)',
  groupHigh: 'High Group (Grades 5-6)',
  groupJunior: 'Junior High Group (Grades 7-9)',
  groupSenior: 'Senior High Group (Grades 10-12)',
  // ID Card Types
  idCardTypeIdCard: 'ID Card',
  idCardTypePassport: 'Passport',
  // Gender
  sexMale: 'Male',
  sexFemale: 'Female',
  // Registration Section Functions
  startCompetition: `Start
  Competition`,
  scoreQuery: `Score
  Inquiry`,
  feedback: 'Feedback',
  message: `Message
  Notification`,
  notOpen: 'Not Open',
  // Message List
  all: 'All',
  unread: 'Unread',
  read: 'Read',
  messageDetail: 'Message Detail',
  // Apply Unlock Code
  sendEmailNotification: 'Send email notification for application result?',
  // Unlock Success
  unlockSuccessMessage: 'Congratulations on your successful registration! Please prepare actively and strive for excellent results!',
  // Send Email Related
  sendEmail: 'Send Email',
  recipient: 'Recipient',
  emailContent: 'Email Content',
  defaultEmailContent: 'Hello, your redemption code has been generated. Please check.',
  sendEmailSuccess: 'Email sent successfully',
  sendEmailFailed: 'Failed to send email',
  pleaseEnterEmail: 'Please enter email',
  redemptionCode: 'Redemption Code',
  tips: 'Tips',
  later: 'Later',
  identityNotAuthorizedMsg: 'You are not yet a committee teacher. Please click the "Apply for Registration" button below to submit your application information first. Thank you for your understanding and support!',
  statistics: 'Statistics',
  people: 'People',
  deleteQualification: 'Delete Qualification',
  editPromotion: 'Edit Promotion',
  regionalQualification: 'Regional Qualification',
  qualificationCode: 'Qualification Code',
  isPay: 'Payment Status',
  notPaid: 'Not Paid',
  paid: 'Paid',
  scoreNotFound: 'Your score was not found',
  scoreNotFoundDesc: 'Sorry, we could not find your score information for the current race schedule. Please try again later or contact customer service.',
  congratulationsPromoted: 'Congratulations on your promotion!',
  notPromotedMessage: 'Unfortunately, you did not advance. Please keep working hard!',
  selectRaceScheduleForScoreQuery: 'Select Race Schedule to Query Score',
  selectRaceScheduleForScoreQueryTip: 'Please select the race schedule to query your score',
  query: 'Query',
  registerRegionalFinal: 'Register for Regional Final',
  registerNationalFinals: 'Register for National Finals',
  isAllocated: 'Allocation',
  allocated: 'Allocated',
  notAllocated: 'Not Allocated',
  allocatedEmail: 'Allocated Email',
  expand: 'Expand',
  collapse: 'Collapse',
  noAllocatedEmail: 'No allocated email information',
  // Player Registration Info Details Page
  playerRegistInfoDetails: 'Player Registration Info Details',
  getTempCode: 'Get Temporary Code',
  getTempCodeFailed: 'Failed to get temporary code',
  male: 'Male',
  female: 'Female',
  idCardType: 'ID Type',
  passport: 'Passport',
  schoolProvinceCity: 'School Province/City/Area',
  addressInfo: 'Address Information',
  receiptName: 'Recipient Name',
  receiptPhone: 'Recipient Phone',
  provinceCityArea: 'Province/City/Area',
  detailAddress: 'Detail Address',
  defaultAddress: 'Default Address',
  couponInfo: 'Coupon Information',
  coupon: 'Coupon',
  discountAmount: 'Discount Amount',
  couponType: 'Coupon Type',
  fullReduction: 'Full Reduction',
  noThreshold: 'No Threshold',
  minimumPurchase: 'Minimum Purchase',
  expirationDate: 'Expiration Date',
  useStatus: 'Use Status',
  useDate: 'Use/Withdraw/Expiry Date',
  couponStatus: 'Coupon Status',
  onShelf: 'On Shelf',
  offShelf: 'Off Shelf',
  enrollmentInfo: 'Enrollment Information',
  contact: 'Contact',
  productName: 'Product Name',
  openType: 'Open Type',
  participationMethod: 'Participation Method',
  answered: 'Answered',
  notAnswered: 'Not Answered',
  openTime: 'Open Time',
  orderInfo: 'Order Information',
  expiryDate: 'Word Bank Expiry Date',
  quantity: 'Quantity',
  totalPrice: 'Total Price',
  unitPrice: 'Unit Price',
  orderName: 'Order Name',
  orderAmount: 'Order Amount',
  paymentAmount: 'Payment Amount',
  orderSource: 'Order Source',
  orderTime: 'Order Time',
  isSend: 'Is Send',
  needSend: 'Need Send',
  noNeedSend: 'No Need Send',
  orderStatus: 'Order Status',
  unknown: 'Unknown',
  schoolName: 'School Name',
  orderNo: 'Order No.',
  // National Final Page
  areaPromoteNoPayPlayer: 'Area Promoted No Pay Players',
  nationalFinalPlayerInfo: 'National Final Player Info',
  playerInfoFilter: 'Player Info Filter',
  pleaseSelectType: 'Please Select Type',
  paymentStatus: 'Payment Status',
  playerInfoList: 'Player Info List',
  nationalFinalNo: 'National Final No.',
  personalInfoDetails: 'Personal Info Details',
  personalDetailInfo: 'Personal Detail Info',
  detailCompleted: 'Completed',
  detailIncomplete: 'Incomplete',
  playerIdentity: 'Player Identity',
  englishNationalPromoted: 'English National Promoted',
  regionalFinalPromoted: 'Regional Final Promoted',
  reviewStage: 'Review Stage',
  orderDetails: 'Order Details',
  editReviewStatus: 'Edit Review Status',
  nationalFinalOrderInfo: 'National Final Order Info',
  basicInfo: 'Basic Info',
  detailInfo: 'Detail Info',
  schoolLocation: 'School Location',
  englishName: 'English Name',
  birthDate: 'Birth Date',
  yearsOld: 'Years Old',
  chineseZodiac: 'Chinese Zodiac',
  zodiac: 'Zodiac',
  prizeMailAddress: 'Prize Mail Address',
  fatherContact: 'Father Contact',
  motherContact: 'Mother Contact',
  playerHeight: 'Player Height',
  playerWeight: 'Player Weight',
  accompanyingParentHeightWeight: 'Accompanying Parent Height/Weight',
  number: 'No.',
  position: 'Position',
  motto: 'Motto',
  hardestChineseCharacter: 'Hardest Chinese Character for Me',
  hobbies: 'Hobbies',
  favoriteBook: 'Favorite Book',
  favoriteSport: 'Favorite Sport',
  favoriteSubject: 'Favorite Subject',
  messageToOtherPlayers: 'Message to Other Players',
  significanceOfNationalCompetition: 'Significance of National Competition',
  whatWouldYouDoWithPrize: 'What Would You Do With Prize?',
  playerNotCompleteDetailInfo: 'Player has not completed detail info～',
  noOrderInfo: 'No Order Info～',
  orderPaid: 'Order Paid',
  orderNotPaid: 'Order Not Paid',
  offlinePayment: 'Offline Payment',
  paymentMethod: 'Payment Method',
  paymentVoucher: 'Payment Voucher',
  clickToViewLargeImage: 'Click to View Large Image',
  paidProducts: 'Paid Products',
  giftProducts: 'Gift Products',
  items: 'Items',
  free: 'Free',
  totalAmount: 'Total Amount',
  confirmPayment: 'Confirm Payment',
  reviewStatus: 'Review Status',
  pleaseSelectReviewStatus: 'Please Select Review Status',
  pendingReview: 'Pending Review',
  reviewRejected: 'Rejected',
  reviewApproved: 'Approved',
  uploadPaymentVoucher: 'Upload Payment Voucher',
  uploadPaymentVoucherNotice: 'After uploading the payment voucher, the order status will change to "Paid". If you need to modify the order, you can still modify the order details and order price in the order details.',
  uploadImage: 'Upload Image',
  pleaseUploadImageFormat: 'Please Upload Image Format',
  confirmModifyPaymentStatus: 'Confirm Modify Payment Status?',
  confirmSuccess: 'Confirm Success',
  reviewStatusUpdateSuccess: 'Review Status Update Success',
  confirmModifyOrderPrice: 'Confirm Modify Order Price?',
  orderPriceUpdateSuccess: 'Order Price Update Success',
  updateFailed: 'Update Failed',
  addFailed: 'Add Failed',
  pleaseEnterModifyRemark: 'Please Enter Modify Remark',
  confirmModifyAgain: 'Please Confirm Modify Again?',
  updateSuccess: 'Update Success',
  // Area Promoted No Pay Players Page
  group: 'Group',
  pleaseEnter: 'Please Enter',
  confirmOrderInfo: 'Confirm Order Info',
  pleaseEnterRemark: 'Please Enter Remark',
  confirmOfflinePayment: 'Confirm Offline Payment',
  uploadPaymentVoucherRequired: 'Please Upload Payment Voucher',
  confirmOfflinePaymentSuccess: 'Confirm Offline Payment Success',
  playerSubmittedOrderNotice: 'This player has already submitted an order in the WeChat Mini Program. Please search for this player in the "National Final Player Info" list to perform offline payment.',
  // 试卷管理
  examPaperManagement: 'Exam Paper Management',
  examPaperManagementDesc: 'Create, edit and manage exam papers',
  examPaperDownload: 'Exam Paper Download',
  examPaperDownloadMenuDesc: 'Download exam paper images and audio files by group',
  examPaperDownloadCenter: 'Exam Paper Download Center',
  examPaperDownloadDesc: 'Download exam paper images and audios by group (sample links, replace later)',
  batchDownloadAll: 'Batch Download All',
  examPaperImageFile: 'Exam Paper Image',
  audioFile: 'Audio File',
  preview: 'Preview',
  audioPreview: 'Listen',
  downloadExamPaperImage: 'Download Paper Image',
  downloadAudio: 'Download Audio',
  groupPrimarySimple: 'Primary Junior Group',
  groupMiddleSimple: 'Primary Middle Group',
  groupHighSimple: 'Primary Senior Group',
  groupJuniorSimple: 'Junior High Group',
  downloadUrlMissing: 'Download URL is missing',
  onlyHttpsDownload: 'Only HTTPS download URLs are supported',
  downloadFallbackTip: 'Direct download is not supported for this resource. Opened original link instead; please check CORS/download settings on file server',
  batchDownloadTriggered: 'Batch download triggered. Please allow multiple downloads in browser',
  batchZipSuccess: 'ZIP package generated and download started',
  batchZipFailed: 'Failed to generate ZIP package. Please try again later',
  batchZipAllFailed: 'All file downloads failed, ZIP package cannot be generated',
  batchZipPartialSuccess: 'ZIP downloaded, but {count} files failed to fetch',
  examPaperList: 'Exam Paper List',
  conditionFilter: 'Condition Filter',
  examPaperName: 'Exam Paper Name',
  examPaperType: 'Exam Paper Type',
  pleaseEnterExamPaperName: 'Please enter exam paper name',
  pleaseSelectExamPaperType: 'Please select exam paper type',
  addExamPaper: 'Add Exam Paper',
  formalExamPaper: 'Official Paper',
  backupExamPaper: 'Backup Paper',
  examPaperNameCol: 'Exam Paper Name',
  seasonCol: 'Season',
  districtCol: 'District',
  groupCol: 'Group',
  setCol: 'Set',
  statusCol: 'Status',
  enabled: 'Enabled',
  disabled: 'Disabled',
  editExamPaper: 'Edit',
  deleteExamPaper: 'Delete',
  confirmDeleteExamPaper: 'Are you sure to delete this exam paper?',
  set: 'Set',
  district: 'District',
  raceScheduleCol: 'Race Schedule',
  pleaseSelectDistrict: 'Please select district',
  pleaseSelectRaceScheduleCol: 'Please select race schedule',
  pleaseSelectSet: 'Please select Set',
  status: 'Status',
  pleaseSelectStatus: 'Please select status',
  // Exam Paper Edit Related
  examPaperDetail: 'Exam Paper Detail',
  questionTypeSettings: 'Question Type Settings',
  questionTypeSettingsNote: '(Note: Selection order is the question type answering order)',
  questionNum: 'Number',
  pleaseEnterQuestionNum: 'Please enter question number',
  questionTypeScore: 'Score',
  pleaseEnterScore: 'Please enter question score',
  confirmQuestionType: 'Confirm Question Type',
  resetQuestionType: 'Reset Question Type',
  questionList: 'Question List',
  editQuestion: 'Edit',
  editQuestionNote: '(Note: If not edited, the system will randomly select questions from the question bank for this group)',
  questionScore: 'Question Score',
  inLexicon: 'In Lexicon',
  inLexiconYes: 'In Lexicon',
  inLexiconNo: 'Not in Lexicon',
  isTestQuestion: 'Is Test Question',
  isTestQuestionYes: 'Yes',
  isTestQuestionNo: 'No',
  wordCategory: 'Word Category',
  pleaseSelectQuestionType: 'Please Select Question Type',
  questionBankList: 'Question Bank List',
  saveCurrentQuestions: 'Save Current Questions',
  questionTypeName: 'Question Type Name',
  questionAnswer: 'Question Answer',
  pleaseEnterWord: 'Please enter word',
  inLexiconFilter: 'In Lexicon',
  confirmDeleteQuestion: 'Are you sure you want to delete this question?',
  text: 'Text',
  pleaseEnterText: 'Please enter text',
  clickToSelect: 'Click to Select',
  dragToReorder: 'Long press to drag and reorder',
  totalQuestions: 'Total Questions',
  noQuestionTypeSelected: 'Please select question types and confirm first',
  noQuestionData: 'No question data',
  examTimeManagementDesc: 'Create, edit and manage time schedules',
  confirmResetQuestionType: 'Are you sure you want to reset the question type settings? All selected question types and question data will be cleared after reset.',

  classManage: 'Class Management',
  trialClassManage: 'Trial Class',
  schoolPicUrl: 'School Logo',
  foundingYear: 'Founding Year',
  schoolMotto: 'School Motto',
  schoolProfile: 'School Profile',
  addTeacher: 'Add Teacher',
  schoolInfo: 'School Information',
  teachers: 'Teacher Management',
  username: 'Username',
  openState: 'Enable',
  closeState: 'Disable',
  createGrade: 'Create Grade',
  editGrade: 'Edit Class Name',
  createClass: 'Create Trial Class',
  courseName: 'Trial Class Name',
  optionalChineseCharacters: 'Optional Chinese Characters',
  selectedChineseCharacters: 'Selected Chinese Characters',
  pleaseInputName: 'Please Enter Trial Class Name',
  pleaseSelectClass: 'Please Select Class',
  pleaseSelectWord: 'Please Select Characters',
  startCourse: 'Start Course',
  State: 'State',
  pleaseSelectState: 'Please select a state',
  pleaseSelectSchool: 'Please select a school',
  pleaseInputSchool: 'Please enter the school name',
  completeInformation: 'Please complete your personal information.',

  getSchoolListFailed: 'Failed to get school list',
  getGradeListFailed: 'Failed to get grade/class list',
  createGradeSuccess: 'Created successfully',
  operateFailed: 'Operation failed',
  confirmDeleteClass: 'Are you sure to delete this class?',
  editSuccess: 'Updated successfully',
  pleaseEnterClassName: 'Please enter class name',
  pleaseEnterGrade: 'Please enter or select grade',

  backToClassManage: 'Back to Class Management',
  studentListOfClass: 'Student List',
  downloadStudentTemplate: 'Download Import Template',
  batchDeleteStudents: 'Batch Delete',
  confirmBatchDeleteStudents: 'Are you sure to delete the selected students?',
  noClassSelected: 'Please select a class from Class Management',
  addOverseasStudent: 'Add Student',
  identity: 'Identity',
  identity3: 'National Organizing Committee',
  identity2: 'School Organizing Committee',
  identity4: 'Teacher',
  noschool: "Don't see your school? Click here to add it",
  selschool: 'Go to select a school',
  match: 'Match',
  noData1: 'No competition area has been allocated yet',
  createMatch: 'Create Match',
  matchName: 'Match Name',
  pleaseInputName2: 'Please enter name',
  grouping: 'Grouping',
  createPaper: 'Paper',
  groupName: 'Group Name',
  num: 'Number',
  choosed: 'Selected',
  canChoose: 'Available',
  showQRcode: 'QR Code',
  startMatch: 'Enter the Match',
  ready: 'Ready',
  start: 'Start',
  end: 'End',
  ing: 'In Progress',
  groupTip: 'It is recommended to keep the number of people in each group as equal as possible',
  paperTip: 'It is recommended that the number of questions be greater than or equal to the number of people in each group',
  autoGroup: 'Auto Group',
  readySucc: 'Ready',
  startSucc: 'Start Answering',
  endSucc: 'End Answering',
  readyIng: 'Preparing',
  startIng: 'Answering',
  endIng: 'Ended',
  result: 'View Results',
  noPeople: 'Insufficient number of respondents',
  pleaseWait: 'The competition is about to start, please be patient',
  users: 'Contestants answering on this device',
  readyTip: 'Get ready, the competition is about to start',
  completeTip: 'This question has been submitted',
  resetSucc: 'Reset successfully',
  answer: 'Answer',
  searchFont: 'Search for Chinese characters',
  tipContent: 'The maximum connection limit has been exceeded. Please refresh the page and try again.',

  // Student pre-exam entry beforeEnter (/stu/examSemi/be)
  examBeforePageTitleDefault: 'Online Exam',
  examBeforeSubtitle: 'Please complete the exam in a stable and quiet environment.',
  examBeforeInstructions: 'Exam Instructions',
  examBeforeTipDevice: 'Device',
  examBeforeTipDeviceHint: 'Desktop / tablet recommended',
  examBeforeTipNetwork: 'Network',
  examBeforeTipNetworkHint: 'Keep your network stable',
  examBeforeTipStatus: 'Status',
  examBeforeTipStatusHint: 'Progress syncs automatically',
  examBeforeDefer: 'Exit',
  examBeforeStart: 'Start Exam',
  examBeforeRefresh: 'Refresh',
  examBeforeConfirmPlayerTitle: 'Please confirm your information',
  examAnswering: 'Answering',

  // 网站首页
  homes1rounds: 'ROUNDS',
  homes1roundsDesc: 'E-Learn - Preliminary Competition - National/Regional Finals - Global Finals',
  homes1culture: 'CULTURE',
  homes1cultureDesc: "The world's first bilingual spelling event, blending Chinese character heritage with global English spelling.",
  homes1target: 'TARGET',
  homes1targetDesc: 'Learning through competition – creating a global bilingual stage for cross‑cultural youth exchange.',

  homes2tit: 'OUR HONOR',
  homes2nationalChampion: 'CEBSB National Champion',
  homes2ChampionInterviews: 'Champion Interviews',
  homes2tab1name: "Li Duan'ang",
  homes2tab1area: 'Tianjin Division',
  homes2tab1grade: 'Grade 7',
  homes2tab2name: 'Jin Hao',
  homes2tab2area: 'Shanghai Division',
  homes2tab2grade: 'Grade 6',
  homes2tab3name: 'Pan Youqi',
  homes2tab3area: 'Shanghai Division',
  homes2tab3grade: 'Grade 1',

  // section3 E-LEARN
  homes3tit: 'E-LEARN',
  homes3ELearnKit: 'E-Learn Kit',
  homes3ELearnKitDesc: 'Official character bank + Speed Spell game box + mythical plushie blind box – an all‑in‑one set that is fun and educational.',
  homes3MiniProgram: 'Mini Program',
  homes3MiniProgramDesc: 'Digital character bank, three question‑type drills, and AI battle – practise anytime, anywhere, even in short sessions.',
  homes3WebPlatform: 'Web Platform',
  homes3WebPlatformDesc: 'AI Pronouncer + Customized Classroom Learning + Simulated Battles – learn through competition and sharpen skills through practice.',
  homes3ExploreBtn: 'EXPLORE E-LEARN',

  homes4tit: 'AUTHENTIC PARTICIPANT REVIEWS',

  // competition
  comps1tit: 'Registration Qualification',
  comps2tit: 'Competition Schedule',

  // ========== gameType keys ==========
  gameTypeAge: 'Age',
  gameTypeAgeDesc: '7-15 year-old teenagers who are learning Chinese and English.',
  gameTypeArea: 'Area',
  gameTypeAreaDesc: 'The participating area shall be determined by the location of the school where the competitor attends.',
  gameTypeNationality: 'Nationality',
  gameTypeNationalityDesc: 'Open to all nationalities.',
  gameTypePreliminary: 'Preliminary Competition',
  gameTypeCompetitionFormat: 'Competition Format',
  gameTypeRecordingTest: 'Recording+Test',
  gameTypeTimeLimit: 'Time limit',
  gameTypeTimeLimitVal: '20-30 minutes',
  gameTypeCompetitionRules: 'Competition Rules',
  gameTypeCompetitionRulesDesc: 'All questions are multiple-choice with a single correct answer.Please write the correct option in the brackets before each question.',
  gameTypeSection1: 'Section 1',
  gameTypeSection1Desc: 'According to the recordings and pictures, choose matching Chinese characters.',
  gameTypeSection2: 'Section 2',
  gameTypeSection2Desc: 'Homophone Distinction. Please select the radicals and components of the corresponding Chinese characters according to the recording content.',
  gameTypeSection3: 'Section 3',
  gameTypeSection3Desc: 'Similar-form Character Distinction. Please select the radicals and components of the corresponding Chinese characters according to the recording content.',
  gameTypeSection4: 'Section 4',
  gameTypeSection4Desc: 'Ancient Font Selection. Please select the seal script form of the corresponding Chinese characters according to the recording content.',
  gameTypeSampleTest: 'Sample Test (Paper)',
  gameTypeDownload: 'Download',
  gameTypeNationalFinals: 'National/Reginal Finals',
  gameTypeFormat1: 'Format 1',
  gameTypeFormat1Desc: 'Device-Based Answering. The authorized organizer may use the competition system to play the recordings and monitor the progress of the competition on-site or remotely. Students shall log in to the designated website via tablet or computer to access the answering system.',
  gameTypeFormat2: 'Format 2',
  gameTypeFormat2Desc: 'Oral Spelling. This requires a judges panel to be set up on-site, consisting of 1 director, 1 pronouncer, 1 judge, and 1 timekeeper/recorder. The pronouncer provides verbal clues in Chinese related to the target character. Based on these clues, the speller should select 2 options to assemble the correct Chinese character.',
  gameTypeHomophone: 'Homophone Distinction',
  gameTypeHomophoneDesc: 'Please select the radicals and components of the corresponding Chinese characters according to the recording content.',
  gameTypeSimilarForm: 'Similar-form Character Distinction',
  gameTypeSimilarFormDesc: 'Please select the radicals and components of the corresponding Chinese characters according to the recording content.',
  gameTypeAncientFont: 'Ancient Font Selection',
  gameTypeAncientFontDesc: 'Please select the seal script form of the corresponding Chinese characters according to the recording content.',
  gameType1v1Spelling: '1v1 Spelling',
  gameType1v1SpellingDesc: '1v1 Spelling.The pronouncer shall provide the pronunciation and the English definition of the target Chinese character. The speller should select and assemble the corresponding character components on the screen. The speller is permitted to request further clues by posing questions. The available question types are as follows:',
  gameTypeQ1: 'Q1【Repeat, please】',
  gameTypeQ1Desc: 'Requesting that the pronouncer repeat the pronunciation of the character.',
  gameTypeQ2: 'Q2【Tone, please】',
  gameTypeQ2Desc: 'Requesting that the pronouncer provide the tone of the character.',
  gameTypeQ3: 'Q3【Pinyin, please】',
  gameTypeQ3Desc: 'Requesting that the pronouncer provide the pinyin of the character. The screen will display it for 3 seconds.',
  gameTypeQ4: 'Q4【Ancient font, please】',
  gameTypeQ4Desc: 'Requesting that the pronouncer provide the ancient font of the character. The screen will display it for 3 seconds.',
  gameTypeQ5: 'Q5【Translation, please】',
  gameTypeQ5Desc: 'Requesting that the pronouncer provide the English meaning of the character.',
  gameTypeQ6: 'Q6【Sentence, please】',
  gameTypeQ6Desc: 'Requesting that the pronouncer provide the English sentence including the meaning of the character.',
  gameTypeOnlineCompetition: 'Online Competition',
  gameTypeGlobalFinals: 'Global Finals',
  gameTypeGlobalFinalsDesc1: "The CEBSB Global Finals is the year's most anticipated bilingual cultural event, bringing together young learners from China and around the world for a unique journey into the beauty of Chinese characters and the richness of Chinese culture.",
  gameTypeGlobalFinalsDesc2: "Centered on Chinese characters, the event features engaging, hands-on activities such as radical and component combination challenges, homophone discrimination games, and idiom storytelling sessions. These immersive experiences help participants easily grasp the structural logic and cultural meaning behind each character. In addition, the Finals offer cultural workshops, traditional craft experiences, and themed exchange activities that give overseas students a vivid glimpse into China's history and folk traditions.",
  gameTypeGlobalFinalsDesc3: 'More importantly, this event serves as a bridge of friendship among young people from different cultural backgrounds. Through collaboration and sharing, participants exchange their languages and cultures, deepen mutual understanding, and broaden their global perspectives. The Global Finals is not just a learning adventure - it is an unforgettable cross-cultural experience.',
  gameTypeCity: 'City',
  gameTypeCityVal: 'Hangzhou, China',
  gameTypeDate: 'Date',
  gameTypeDateVal: 'October 30 - November 1, 2026',
  gameTypeSchedule: 'Schedule',
  gameTypeDay1: 'Day 1',
  gameTypeDay1Val: 'Registration & Opening Ceremony',
  gameTypeDay2: 'Day 2',
  gameTypeDay2Val: 'Competition Activities & Dinner Banquet & Carnival',
  gameTypeDay3: 'Day 3',
  gameTypeDay3Val: 'Mixed-Group Finals & Awards Ceremony',
  gameTypeQualification: 'Global Finals Qualification',
  gameTypeRegistration: 'Registration',
  gameTypeRegisterNow: 'Register Now',
  gameTypeFormat: 'Format',
  gameTypeLocation: 'Location',
  gameTypeDivisionFinals: 'Division Finals',
  gameTypeNationalFinalsRound: 'National Finals',
  gameTypeDomF1V1: 'Paper Test + Listening',
  gameTypeDomF1V2: 'Mar-Jun, 2026',
  gameTypeDomF1V3: 'On-campus/Online',
  gameTypeDomF2V1: 'Answering Questions via Mini-program',
  gameTypeDomF2V2: 'Apr-Sep, 2026',
  gameTypeDomF2V3: 'Off-campus/Online',
  gameTypeDomF3V1: 'Pronunciation by Foreign Teachers, Intelligent Answering System + On-site Spelling',
  gameTypeDomF3V2: 'Oct, 2026',
  gameTypeDomF3V3: 'Designated by the Organizing Committee',
  gameTypeOverF1V1: 'Paper Test + Listening',
  gameTypeOverF1V2: 'Jan-Apr, 2026',
  gameTypeOverF1V3: 'On-campus/Online',
  gameTypeOverF2V1: 'Answering Questions via Mini-program',
  gameTypeOverF2V2: 'Apr-Jun, 2026',
  gameTypeOverF2V3: 'Off-campus/Online',
  gameTypeOverF3V1: 'Pronunciation by Foreign Teachers, Intelligent Answering System + On-site Spelling',
  gameTypeOverF3V2: 'Oct, 2026',
  gameTypeOverF3V3: 'Designated by the Organizing Committee',
  // ========== homes4 testimonial keys ==========
  homes4S1Username: 'Su**Tong',
  homes4S1Grade: 'Tianjin, Grade 7',
  homes4S1Content: 'I study in an international school, where the classes are primarily taught in English. My parents worried that my Chinese might weaken, so they signed me up for this competition. I participated in the first National Finals in Beijing. This competition uses English clues to piece together Chinese characters. It was actually my first time exploring the logical structures and cultural stories behind Chinese characters, and I truly felt the unique beauty of Chinese characters. I am very grateful to this competition.',
  homes4S2Username: 'Zhou**Heng',
  homes4S2Grade: 'Guangzhou, Grade 6',
  homes4S2Content: 'My aspiration is to become a diplomat with bilingual communication skills. The experience of preparing for the CEBSB made me realize that the preparation process is more memorable than the competition itself. This competition involves the seal script forms of Chinese characters, so beyond studying the character bank, I also researched the evolution of characters on my own. When I encountered unfamiliar seal script characters, I looked up ancient texts and related historical backgrounds. Throughout this process, my learning horizons broadened, and my research skills improved naturally. I believe this is the most valuable experience I have gained.',
  homes4S3Username: 'Lin**Nuo',
  homes4S3Grade: 'Hangzhou, Grade 4',
  homes4S3Content: "My mom signed me up for this competition, so I never expected to have made friends here! During last year's National Finals in Luoyang, I met fellow competitors in my group. We chatted every day, shared Chinese character stories and useful techniques, and studied difficult character components together. We've stayed in touch even after the competition—not only sharing academic discussions but also everyday life. For me, the ranking is just the icing on the cake; being able to meet good friends here was something I never anticipated.",
  homes4S4Username: 'Ms. Li',
  homes4S4Grade: 'Beijing, Bilingual School Teacher',
  homes4S4Content: 'Working at an international school, I am well aware of the prevalent issue of "prioritizing English over Chinese" in many schools. I brought fourth-grade students to participate in the CEBSB, and three of them made it to the National Finals, so I also attended the on-site finals. The entire competition system has provided me with new ideas for teaching. By integrating English definitions with Chinese characters, it has largely bridged the gap between the two languages. I have heard that an AI-powered intelligent learning system has now been added. I look forward to using it in school-based curricula and after-school club language activities to enrich the students learning experience on campus.',
  homes4S5Username: 'Ms. Smith',
  homes4S5Grade: 'New Jersey, Leading Teacher in CEBSB North American League Competition',
  homes4S5Content: 'As a Chinese language teacher at an immersive Chinese-language school in North America, I had the privilege of leading my students to participate in the CEBSB North American League Competition. Previously, many overseas Chinese youth found Chinese difficult—recognizing characters and distinguishing pronunciations had long been learning challenges. However, I believe this experience has broken the traditional model of international Chinese classrooms. The competition, which integrates gamified competition, has encouraged children to proactively engage with Chinese characters. During preparation, the children transitioned from passively completing assignments to actively exchanging knowledge about Chinese—I am truly gratified. CEBSB has built an excellent platform, and I hope this efficient and enjoyable learning model can be brought to more Chinese language learners and cultural exchangers.',
  // ========== exerResult ==========
  exerResultEvent: 'Events',
  exerResultFunLearning: 'Fun Learning',
  exerResultPracticeComplete: 'Practice Complete',
  exerResultTimeUsed: 'Time Used',
  exerResultScore: 'Score',
  exerResultAttempts: 'Attempts',
  exerResultDetails: 'Answer Details',
  exerResultIncomplete: 'Incomplete',
  exerResultWrong: 'Wrong',
  exerResultCorrect: 'Correct',
  // ========== eLearn ==========
  eleLearnStudent: 'Student Portal',
  eleLearnTeacher: 'Teacher Portal',
  eleLearnOrganizer: 'Organizer Portal',
  eleLearnDesc: 'E‑Learn is an all‑in‑one E-Learn platform created by CEBSB for both participants and coaches. It covers student and teacher portals, following a clear path of character bank learning → question‑type training → simulated battles. Our goal is to help global learners improve their bilingual (Chinese‑English) competence through engaging, interactive practice.',
  // ========== eLearn Section2 ==========
  eleS2Title: 'Student Portal',
  eleS2Subtitle: 'Digital Character Bank + Targeted Drills',
  eleS2RegDesc: 'Every overseas participant who successfully registers will receive immediate access to the official online character bank – no physical materials required. Access is activated upon registration.',
  eleS2C1Tit: 'Bilingual Digital Character Bank',
  eleS2C1Desc: 'Built on the "character-centered" linguistic approach, the bank is aligned with the Chinese Proficiency Standards for International Chinese Language Education (HSK 1-9). It covers frequently used characters and vocabulary from beginner to advanced levels, with a strong focus on character structure and cultural context. This helps learners build a complete cognitive chain – from "recognising" to "using" characters. Each entry comes with standard English definitions and audio pronunciations, enabling true bilingual learning.',
  eleS2C2Tit: 'Three Core Question-Type Drills',
  eleS2C2Intro: 'Participants can practise directly in the web system with the three main question types:',
  eleS2C2Item1: 'Magic Component',
  eleS2C2Item1Desc: 'Listen and select the correct Chinese Character or component.',
  eleS2C2Item2: 'Magic Radical',
  eleS2C2Item2Desc: 'Listen and select the correct radical.',
  eleS2C2Item3: 'Crazy Homophone',
  eleS2C2Item3Desc: 'Combine the correct component and radical to form a character.',
  eleS2C2Ending: 'Each practice round generates random questions and provides instant feedback, helping learners reinforce their understanding of character sounds, shapes, and meanings through repeated practice.',
  eleS2C3Tit: 'AI-Powered Simulated Battles',
  eleS2C3Desc: 'An integrated AI battle system allows participants to start a simulated match at any time. This virtual competition environment lets them test their progress and get comfortable with the pace and pressure of the real contest.',
  // ========== eLearn Section3 Teacher Portal ==========
  eleS3Title: 'Teacher Portal',
  eleS3Subtitle: 'Customised Classroom System',
  eleS3Intro: 'E-Learn provides a dedicated teaching system for coaches, making it easy to organise in-school instruction and selection:',
  eleS3C1Tit: 'Class & Student Management',
  eleS3C1Desc: 'Teachers can create classes, import student rosters, and monitor the learning progress and completion status of the whole class in real time.',
  eleS3C2Tit: 'In-Class Simulated Battles',
  eleS3C2Desc: 'Launch simulated battles on the classroom screen or on student devices. Both individual and team formats are supported, creating an authentic contest atmosphere and boosting classroom engagement.',
  eleS3C3Tit: 'Customised Task Assignment',
  eleS3C3Desc: 'Based on teaching schedules, teachers can assign targeted practice tasks to the entire class or to specific students.',
  // ========== eLearn Section4 Key Highlights ==========
  eleS4Title: 'Key Highlights',
  eleS4C1Tit: 'Instant Access',
  eleS4C1Desc: 'No need to wait for physical materials. Upon successful registration, you can log in and use the complete character bank immediately.',
  eleS4C2Tit: 'Three-Tier Character Bank',
  eleS4C2Desc: 'Referencing the HSK standards, the bank is graded to suit learners at different Chinese proficiency levels.',
  eleS4C3Tit: 'Integrated Learning Cycle',
  eleS4C3Desc: 'Character bank learning → question-type drills → AI simulated battles → progress tracking – forming a complete closed loop.',
  eleS4C4Tit: 'Teacher-Empowered',
  eleS4C4Desc: 'It supports classroom battles and learning analytics, fulfilling the philosophy of "learn through competition and sharpen skills through practice."',
  // ========== Global Finals Section1 ==========
  gfS1Title: 'Global Finals',
  gfS1Desc1: 'The CEBSB Global Finals is an annual bilingual cultural celebration that brings together young people from China and around the world to explore the beauty of Chinese characters and the richness of Chinese culture.',
  gfS1Desc2: "Centered around Chinese characters, the event features fun, hands‑on activities such as radical combination challenges, homophone games, and idiom storytelling. These immersive experiences help participants easily grasp the structure and cultural meaning of Chinese characters. The Finals also offer cultural workshops and traditional craft experiences, giving overseas students a vivid glimpse into China's history and folk customs.",
  gfS1Desc3: 'More importantly, it serves as a bridge of friendship among young people from different cultural backgrounds. Through collaboration and exchange, participants share their languages and cultures, deepen mutual understanding, and broaden their horizons. The Global Finals is truly an unforgettable journey of cross‑cultural discovery.',
  // ========== Global Finals Section2 ==========
  gfS2Title: 'Event Info of 2026 Global Finals',
  gfS2City: 'City',
  gfS2CityVal: 'Hangzhou, China',
  gfS2Date: 'Date',
  gfS2DateVal: 'October 30 – November 1, 2026',
  gfS2Schedule: 'Schedule',
  gfS2Activity: 'Activity',
  gfS2CheckIn: 'Check‑in & Registration, Material Collection, Hotel Check‑in',
  gfS2Opening: 'Opening Ceremony',
  gfS2GroupQualifying: 'Group Qualifying Competition',
  gfS2GroupChampionship: 'Group Championship Competition',
  gfS2GalaDinner: 'Global Social Gala Dinner',
  gfS2Bazaar: 'Chinese‑Culture Bazaar',
  gfS2MixedFinals: 'Mixed‑Group Global Finals',
  gfS2Awards: 'Awards Ceremony',
  gfS2Arrangements: 'Accommodation, transportation and other relevant arrangements for Global Finals will be announced prior to the final competition.',
  gfS2SpecialEvents: 'Special cultural events for the Finals: Chinese‑Culture Exchange Camp, Exchange & Social Gathering for Chinese and International spellers (to be announced)',

  gfS3Title: 'Hall of Fame',
  // ========== Global Finals Section4 ==========
  gfS4Title: 'Awards & Honors',
  gfS4Card1Tit: 'Prizes for Mixed-Group Champion',
  gfS4Card1Desc: "In the global finals' mixed-group competition, the overall global champion, runner-up, and second runner-up will be determined and awarded corresponding cash prizes and certificates.",
  gfS4Card2Tit: 'Top-3 in Each Group',
  gfS4Card2Desc: 'The group finals will crown the champion, runner-up, and second runner-up in each category, with corresponding awards and certificates presented to the winners.',
  gfS4Card3Tit: 'Special Question-Type Award',
  gfS4Card3Desc: 'Outstanding performers in special question types will also be recognized with special awards.',
  gfS4AwardDesc: 'Award Description of Global Model School, Outstanding Organizer, Outstanding Instructor',
  gfS4ModelSchoolTit: 'Global Model School',
  gfS4ModelSchoolDesc: 'Schools that have actively hosted campus preliminary selections for multiple consecutive years, and whose students have consistently achieved excellent results over successive seasons, will be honored with the "Global Model School" title.',
  gfS4OrgTit: 'Outstanding Organizer',
  gfS4OrgDesc: 'Schools that have actively hosted campus preliminary selections for multiple consecutive years will be honored with the "Outstanding Organizer" title.',
  gfS4InstructorTit: 'Outstanding Instructor',
  gfS4InstructorDesc: 'Instructors of students who place in the global finals will receive the "Outstanding Instructor" honor.',
  gfS4CertTit: 'Certificates, Trophys, Participation Souvenirs',
  gfS4Cert1: 'Certificates',
  gfS4Cert2: 'Trophys',
  gfS4Cert3: 'Participation Souvenirs',

  // ========== Join Us Dialog ==========
  joinDialogTitle: 'Cooperation Application',
  joinFullName: 'Full Name',
  joinFullNamePh: 'Please enter your full name',
  joinCountry: 'Country',
  joinCountryPh: 'Please select your country',
  joinInstitution: 'School / Institution',
  joinInstitutionPh: 'Please enter your school or institution',
  joinEmail: 'Email',
  joinEmailPh: 'Please enter your email address',
  joinEmailRequired: 'Email is required',
  joinEmailInvalid: 'Please enter a valid email address',
  joinPurpose: 'Purpose of Contact',
  joinPurposePh: 'Please describe your purpose of contact',
  joinNote: 'Remark',
  joinNotePh: 'Additional notes (optional)',
  joinSuccess: 'Submitted successfully! We will contact you soon.',
  // ========== Global Finals Registration Form ==========
  gfRegFormTitle: 'Registration',
  gfRegFirstName: 'First Name',
  gfRegFirstNamePh: 'Please enter your first name',
  gfRegLastName: 'Last Name',
  gfRegLastNamePh: 'Please enter your last name',
  gfRegNationality: 'Nationality',
  gfRegNationalityPh: 'Please select your nationality',
  gfRegCity: 'City',
  gfRegCityPh: 'Please enter your city',
  gfRegBirthDate: 'Date of Birth',
  gfRegBirthDatePh: 'Please select your date of birth',
  gfRegTshirtSize: 'T-Shirt Size',
  gfRegTshirtSizePh: 'Please enter T-Shirt size',
  gfRegParentsNum: 'Number of Accompanying Parents',
  gfRegParentsNumPh: 'Please enter number of accompanying parents',
  gfRegContactEmail: 'Contact Email',
  gfRegContactEmailPh: 'Please enter your contact email',
  gfRegEmailInvalid: 'Please enter a valid email address',
  gfRegSubmitSuccess: 'Submitted successfully! We will contact you soon.',
  joinCooperationItems: 'Cooperation Items',
  joinScopeCategory: 'Cooperation Scope Categories',
  joinTeacherTraining: 'Teacher Training',
  joinTeacherTrainingOrgDesc: 'Train teachers from authorized organizing committees/schools in E-learn and event organization and provide detailed guidelines and corresponding materials/resources',
  joinTeacherTrainingSchoolDesc: 'Receive project training on time and in accordance with requirements',
  joinAiGamifiedLearning: 'AI Gamified E-Learn',
  joinAiLearningOrgDesc: 'Provide the AI gamified E-Learn platform and maintain relevant accounts',
  joinAiLearningSchoolDesc: 'Use the platform for character learning and games',
  joinCampusPreliminary: 'Campus Preliminary Selection',
  joinCampusOrgDesc: 'Provide preliminary selection test papers and other materials',
  joinCampusSchoolDesc: 'Organize students within the region/school to participate in the preliminary selection',
  joinNationalRegionalFinals: 'National/Regional Finals',
  joinNationalOrgDesc: 'Provide necessary competition support and system support',
  joinNationalSchoolDesc: "Organize students within the region to participate and ensure the finals comply with the Global Organizing Committee's standardization",
  joinGlobalFinals: 'Global Finals',
  joinGlobalOrgDesc: 'Take full responsibility for the comprehensive on-site support and services for the Global Finals',
  joinGlobalSchoolDesc: 'Provide necessary assistance for the event',
  joinOrgCommittee: 'CEBSB Global Organizing Committee',
  joinAuthCommittee: 'Authorized Committee/School',
  joinAuthModel: 'Authorization Model',
  joinModel1Title: 'Model 1: For Countries/Regions',
  joinModel2Title: 'Model 2: For Schools/Institutions',
  joinModel1PositioningDesc: 'Target Partners: Educational institutions and international Chinese language education organizations outside of China mainland. We grant them exclusive rights to operate the competition in designated countries or regions. This model is ideal for educational institutions seeking to build a regional brand presence and establish a localized operation system.',
  joinModel2PositioningDesc: "Target partners include full-time primary and secondary schools offering Chinese language courses or Chinese language education institutions outside of China mainland. We authorize them as official CEBSB test centers to organize preliminary selection activities on campus. This model is ideal for individual schools seeking to enrich their Chinese language teaching formats and enhance students' bilingual proficiency through the competition.",
  joinCooperationPositioning: 'Cooperation Positioning',
  joinBenefits: 'Benefits',
  joinRegionalExclusive: 'Regional Exclusive/Priority Authorization',
  joinRegionalExclusiveDesc: 'Obtain exclusive or priority rights to operate the competition in a designated country or region.',
  joinBrandAuth: 'Brand Authorization',
  joinBrandAuthDesc: 'Receive official CEBSB brand authorization and status as a regional partner.',
  joinFullProcessSupport: 'Full-Process Operational Support',
  joinFullProcessSupportDesc: 'Access standardized guidelines and support for the entire competition cycle, including event organization, promotion and marketing, and participant recruitment.',
  joinCompetitionFormatAuth: 'Competition Format & Content Authorization',
  joinCompetitionFormatAuthDesc: 'Gain access to comprehensive competition schedule and rules, the official character bank system, and question-type designs.',
  joinGlobalFinalsPathway: 'Global Finals Pathway',
  joinGlobalFinalsPathwayDesc: 'Regional winners are eligible for direct advancement to the Global Finals.',
  joinIntlResourceNetwork: 'International Resource Networking',
  joinIntlResourceNetworkDesc: 'Gain access to the CEBSB global partner network and establish connections with educational institutions worldwide.',
  joinTestCenterAuth: 'Official Test Center Authorization',
  joinTestCenterAuthDesc: 'Receive official CEBSB test center authorization and certification.',
  joinCampusEventPlan: 'On-Campus Event Organization Plan',
  joinCampusEventPlanDesc: 'Gain access to a comprehensive plan for on-campus preliminary selections, including competition format rules and evaluation criteria.',
  joinCharLibraryResources: 'Official Character Library & Learning Resources',
  joinCharLibraryResourcesDesc: 'Gain access to the CEBSB official character library system and AI-powered E-Learn tools.',
  joinAdvancementPathway: 'Participant Advancement Pathway',
  joinAdvancementPathwayDesc: 'On-campus winners are eligible to qualify for the regional rounds and Global Finals.',
  joinTeacherSupport: 'Teacher Support',
  joinTeacherSupportDesc: 'Receive competition-related teacher guidance and teaching resources.',
  joinCooperationApply: 'Cooperation Application',
  joinClickToFillIn: 'Click to Fill In',
  joinContactUs: 'Contact Us',
  joinPleaseFillInOnline: 'Please fill in the following information online',
  joinDialogTitle2: 'Cooperation Inquiry',
  joinContactPerson: 'Contact Person',
  joinContactPersonPh: 'Please enter the contact person',
  joinPosition: 'Position',
  joinPositionPh: 'Please enter the position',
  joinTel: 'Tel',
  joinTelPh: 'Please enter the phone number',
  joinEmail2Ph: 'Please enter your email',
  joinAddress: 'Address',
  joinAddressPh: 'Please enter the address',
  joinSchool: 'School/Institution',
  joinSchoolPh: 'Please enter the school/institution',
  joinInstitutionProfile: 'Institution Profile',
  joinInstitutionProfilePh: 'Please enter the institution profile'

}
